<!-- eslint-disable max-len -->
<template>
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.49984 1.2H15.6665C15.7382 1.2 15.7998 1.2616 15.7998 1.33333V6.33333C15.7998 6.40507 15.7382 6.46667 15.6665 6.46667H1.49984C1.4281 6.46667 1.3665 6.40507 1.3665 6.33333V1.33333C1.3665 1.2616 1.4281 1.2 1.49984 1.2ZM1.49984 9.53333H15.6665C15.7382 9.53333 15.7998 9.59493 15.7998 9.66667V14.6667C15.7998 14.7384 15.7382 14.8 15.6665 14.8H1.49984C1.4281 14.8 1.3665 14.7384 1.3665 14.6667V9.66667C1.3665 9.59493 1.4281 9.53333 1.49984 9.53333Z"
      stroke="#C2CFE0"
      stroke-width="1.4"
    />
  </svg>
</template>
<script>
export default {
  name: 'topics',
};
</script>
